<template>
    <div class="feed_page">
        <div class="pc_box" v-if="!isPhone">
            <img :src="staticImg+slidimg" />
            <img src="@/images/hkzc.jpg" />
        </div>
        <div class="feed_phone" v-if="isPhone">
            <Header2 :searchShow="false" pageTitle="最新活动"></Header2>
            <div class="dh2">
                <p @click="shauXin">文化之旅</p>
            </div>
            <img v-show="isshow" :src="staticImg+slidimg" />
            <div v-show="isshow" class="img_wrap">
                <div class="img_box">
                    <img src="@/images/hkzc2.jpg" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isPhone: this.$isMobile,
            isshow:true,
            slidimg: "",
            staticImg: this.$staticImg,
        };
    },
    created() {
        this.bannerNext();
    },
    methods: {
        // 轮播图下方的图
		async bannerNext() {
			const res = await this.$api.bannerNext();
			if (res.code == 1) {
				this.slidimg = res.data.bannerimg;
			}
		},
        shauXin(){
            this.isshow= false;
            setTimeout(() => {
                this.isshow= true;
            }, 50);
        }
    },
};
</script>

<style lang="scss">
.feed_page {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
    .pc_box {
        margin-top: 76px;
        padding-bottom: 75px;
        min-width: 900px;
        img {
            width: 100%;
        }
    }
    .feed_phone {
        padding: 2.4rem 0 3rem 0;
        background-color: #e7f0f7;
        .dh2 {
            background-color: #fff;
            box-shadow: 0 2px 2px 0 hsla(0, 0%, 60%, 0.1);
            position: fixed;
            width: 100%;
            z-index: 1000;
            top: 1.23rem;
            left: 0;
            right: 0;
            p {
                display: inline-block;
                color: #c00;
                font-size: 15px;
                font-weight: 700;
                height: 1.17rem;
                line-height: 1.17rem;
                margin: 0 0.35rem;
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    width: 1.07rem;
                    height: 3px;
                    background-color: #d43235;
                    left: 50%;
                    margin-left: -0.53rem;
                    bottom: 0;
                    border-radius: 3px;
                }
            }
        }
        img {
            width: 100%;
        }
        .img_wrap {
            padding: 0 0.35rem;
            margin-top: 0.5rem;
            .img_box {
                padding: 0.59rem 0 0.67rem;
            }
        }
    }
}
</style>